export default function WhatsAppButton() {
  const WHATSAPP_URL = 'https://wa.me/5511984095840?text=Ol%C3%A1%2C%20gostaria%20de%20avaliar%20meu%20caso.';

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="nofollow noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full cursor-pointer animate-pulse-gold"
      style={{ background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)' }}
    >
      <i className="ri-whatsapp-line text-white text-2xl md:text-3xl" />
    </a>
  );
}
